import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a2d07e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-7 main-content sm:pr-8" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "w-full bg-white text-project font-bold mt-8 p-8 grid sm:grid-cols-2" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "pl-4 items-center flex" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "sm:col-span-1 h-full min-h-50vh flex flex-col items-center justify-center" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_16 = ["href", "innerHTML"]
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              class: "text-5xl font-bold text-project2",
              innerHTML: _ctx.$t(_ctx.config.title, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              class: "mt-4 text-white font-bold",
              innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", {
                  class: "mt-4 text-project font-bold",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_8),
                _createElementVNode("p", {
                  class: "mt-4 text-project font-bold",
                  innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: _ctx.config.image1,
                  class: "",
                  alt: "phyramid"
                }, null, 8, _hoisted_11)
              ])
            ]),
            _createVNode(_component_BackNextButtons, {
              "color-class": "mt-8 green-button",
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.config.bgImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "w-full aspect-square flex flex-col items-center justify-center",
                  style: _normalizeStyle(_ctx.config.bgStyles)
                }, [
                  _createElementVNode("p", {
                    class: "text-project font-bold mb-4",
                    innerHTML: _ctx.$t(_ctx.config.screenId+'.phyramid', {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_13),
                  _createElementVNode("img", {
                    src: _ctx.config.bgImage,
                    class: "w-full",
                    alt: "Logo"
                  }, null, 8, _hoisted_14)
                ], 4))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_16))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_17))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}